import styled from "styled-components";

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	label {
		font-size: 14px;
		color: #000;
		line-height: 23px;
		margin-bottom: 0;
	}

	.react-datepicker-wrapper {
		width: 100%;
	}

	.react-datepicker__input-container {
		width: 100%;
	}

	.react-datepicker__input-container input {
		padding: 8px 16px;
		border: 1px solid #31475a;
		border-radius: 4px;
		width: 100%;
		box-sizing: border-box;

		font-size: 14px;
		line-height: 23px;

		&::placeholder {
			color: #6c757d;
		}

		&:disabled {
			background-color: #e5e7eb;
			color: #31475a;
		}
	}
`;
